import { render, staticRenderFns } from "./RnaContactForm.vue?vue&type=template&id=24f7ebd9"
import script from "./RnaContactForm.vue?vue&type=script&lang=js"
export * from "./RnaContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports